import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SelectPackage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Fetch all packages on component mount
  useEffect(() => {
    fetchPackages();
  }, []);
  
  // Function to fetch packages from the API
  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/packages");
      if (!response.ok) {
        throw new Error("Failed to fetch packages");
      }
      const data = await response.json();
      setPackages(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching packages:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  
  // Helper function to get package features
  const getPackageFeatures = (pkg) => {
    const features = [];
    if (pkg.pointOne) features.push(pkg.pointOne);
    if (pkg.pointTwo) features.push(pkg.pointTwo);
    if (pkg.pointThree) features.push(pkg.pointThree);
    if (pkg.pointFour) features.push(pkg.pointFour);
    if (pkg.pointFive) features.push(pkg.pointFive);
    if (pkg.pointSix) features.push(pkg.pointSix);
    if (pkg.pointSeven) features.push(pkg.pointSeven);
    if (pkg.pointEight) features.push(pkg.pointEight);
    if (pkg.pointNine) features.push(pkg.pointNine);
    if (pkg.pointTen) features.push(pkg.pointTen);
    return features;
  };
  
  // Icons for features
  const featureIcons = [
    "ti-notepad",
    "ti-file", 
    "ti-light-bulb",
    "ti-star",
    "ti-image",
    "ti-flag"
  ];
  
  return (
    <>
      <section id="pricing" className="price_area section-padding">
        <div className="container">
          <div className="section-title">
            <h2>Pricing Plan</h2>
            <p>
              Popular
              <span> packages</span>
            </p>
          </div>
          
          {loading ? (
            <div className="text-center py-5">
              
            </div>
          ) : error ? (
            <div className="alert alert-danger text-center" role="alert">
              Error: {error}
              <button 
                className="btn btn-outline-danger ms-3" 
                onClick={fetchPackages}
              >
                Try Again
              </button>
            </div>
          ) : (
            <div className="row">
              {packages.map((pkg, index) => (
                <div
                  key={pkg._id || index}
                  className="col-lg-4 col-sm-6 col-xs-12 wow fadeInUp"
                  data-wow-duration="1s"
                  data-wow-delay={`${0.1 * (index + 1)}s`}
                  data-wow-offset={0}
                >
                  <div className="pricing_design">
                    <div className="single-pricing">
                      <div className="price-head">
                        <h2>{pkg.packageName}</h2>
                        <h1 className={pkg.price > 0 ? "price" : ""}>
                          ${pkg.price} USD
                        </h1>
                      </div>
                      <ul>
                        {getPackageFeatures(pkg).map((feature, featIndex) => (
                          <li key={featIndex}>
                            <span className={featureIcons[featIndex % featureIcons.length]} />
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <div className="pricing-price" />
                      <Link 
                        to={pkg.price === 0 ? "/signup" : `/buy/${pkg._id}`} 
                        className="price_btn"
                      >
                        {pkg.price === 0 ? "Start Now" : "Buy Now"}
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SelectPackage;